import { Route } from '@angular/router';

import { SettingsLayoutsComponent } from './layouts.component';
import { SettingsLayoutsListComponent } from './list/list.component';
import { SettingsLayoutsDetailsComponent } from './details/details.component';
import { ProjectDataResolver } from 'app/modules/projects/projects.resolvers';
import { SettingsLayoutResolver } from './layouts.resolvers';

export const settingsLayoutsRoutes: Route[] = [
  {
    path: '',
    component: SettingsLayoutsComponent,
    children: [
      {
        path: '',
        component: SettingsLayoutsListComponent,
        resolve: {
          options: ProjectDataResolver,
        },
      },
      {
        path: ':id',
        component: SettingsLayoutsDetailsComponent,
        resolve: {
          options: ProjectDataResolver,
          projectTemplate: SettingsLayoutResolver,
        },
      },
    ],
  },
];
